import React from 'react';
import { Button as AntdButton, ButtonProps } from 'antd';
import styled from '@emotion/styled';

const StyledButton = styled(AntdButton, {
  shouldForwardProp: (prop) => {
    const extraProps = ['borderRadius'];

    return !extraProps.includes(prop);
  }
})`
  border-radius: ${(props: any) => props.borderRadius || 4}px;
  > span {
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: center;
  }
`;

const Button = (
  props: Partial<
    ButtonProps & {
      borderRadius: number;
    }
  >
) => {
  return <StyledButton {...props}></StyledButton>;
};
export default Button;
